import { Subject } from 'rxjs/Subject';
import { CartService } from './../cart/cart.service';
import { AuthService, User } from './../user/auth.service';
import { Location } from '@angular/common';
import { Gift } from './../gift/gift';
import { RegistryService } from './../registry/registry.service';
import { Registry } from './../registry/registry';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GiftSelection } from '../gift/giftSelection';
import { GiftComponent } from '../gift/gift.component';
import { RegistryComponent } from '../registry/registry.component';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { UserService } from '../user/user.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { ImageUrlService } from '../shared/services/image-url.service';

@Component({

  selector: 'app-gift-detail',
  templateUrl: './gift-detail.component.html',
  styleUrls: ['./gift-detail.component.scss'],
  // providers: [RegistryFirebaseService],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})
export class GiftDetailComponent implements OnInit, OnDestroy {
  gifts: Gift[];
  filteredGifts: Gift[];
  gift: Gift;
  giftSelection: GiftSelection;
  sub: any;
  mode = '';
  giftName: string;
  createMode = false;
  showControls: boolean;
  paidAmount: number;
  showGiftInfo: boolean;
  isLoggedIn = false;
  cartMode = false;
  symbol: string;
  loaded = false;
  currency: string;
  preview = false;
  fundedgift = false;
  fromBag = false;
  bagSize = 0;
  registryName: string;
  activeGifts: Gift[];
  showTranslation = false
  registry: Registry;
  fromContrib = false;
  user: User;
  deleting = false;
anonymousMode = false;
  private ngUnsubscribe: Subject<void> = new Subject();
  pricePerPortion: number;
  portionsRemaining: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registryService: RegistryService,
    private registryFirebaseService: RegistryFirebaseService,
    private _userService: UserService,
    private _location: Location,
    private _authService: AuthService,
    private _cartService: CartService,
    private _analyticsService: AnalyticsService,
    private imageUrlService: ImageUrlService

  ) {

this.anonymousMode = false;
    if (location.pathname.includes('your-registry') ){
      this.anonymousMode = true;
    }
    this._cartService.changeEmitted$.subscribe(() => {
      this.bagSize = this._cartService.getCart().cartItems.length;

    });

    if(localStorage.getItem('showTranslation')){
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }
    this.registry = this.route.snapshot.data.registry;



    this.setBaseTemplate(this.registry);
    
    this.isLoggedIn = this.route.snapshot.data.isLoggedIn;

    if (this.registry && (location.search.includes('preview'))) {
      // this.router.navigate(["coming-soon"]);
      this.gifts = this.registryFirebaseService.getLocalGifts();
      this.preview = true;
      this.isLoggedIn = false;
      this.registryService.setPreview(true);

    }


    if (this.registry && (location.search.includes('fundedgift'))) {
      // this.router.navigate(["coming-soon"]);
      this.fundedgift = true;
    
    }

    if (this.registryService && this.registryService.isPreview && !location.search.includes('preview')) {

      window.history.replaceState({}, document.title, location.href + "?preview=1");

    }


    if (!this.isLoggedIn && this.registry.hasPassword && !this.registryService.passwordOk) {
      this.router.navigate([this.registry.registryName]);
    }


    this.registryFirebaseService.killLoader();
    this.user = this.route.snapshot.data.user;



    this.loaded = true;

    this.gifts = this.route.snapshot.data.gifts;
    if (this.registry) {
      this.symbol = this.registry.symbol;
      this.currency = this.registry.currency;
    }
    if (this.registry && this.registry.giftSort) {
      const sortedGifts = new Array<Gift>();
      this.registry.giftSort.forEach(giftId => {
        const sortGift = this.gifts.filter(x => x.id === giftId)[0];
        if (sortGift) {
          this.gifts = this.gifts.filter(x => x.id !== sortGift.id);
          sortedGifts.push(sortGift);
        }
      });

      this.gifts = (
        this.gifts.sort(function (a, b) {
          return b.createdDate - a.createdDate;
        })
      ).concat(sortedGifts);
    }

    this.bagSize = this._cartService.getCart().cartItems.length;

    this.paidAmount = this.registryService.guestpaymentGiftSubTotal;


    window.scrollTo(0, 0);


    this.route.queryParams
      .subscribe(params => {
        if (params['from'] && params['from'] === 'contrib-detail') {
          this.fromContrib = true;
        }
        if (params['from'] && params['from'] === 'bag') {
          this.fromBag = true;
        }

      });

    this.route.params.subscribe(params => {

      this.registryName = params['registry'];
      this.giftName = params['gifttitle'];
      this.sub = this.route.data.subscribe(data => {
        this.showControls = data['showControls'] as boolean;
        this.createMode = data['createMode'] as boolean;
        this.showGiftInfo = data['showGiftInfo'] as boolean;
        this.cartMode = data['cartMode'] as boolean;
        this.mode = data['mode'] as string;
        this._userService.emitUpdateHeaderType('hidenav');


        // this._authService.user.subscribe(user => {
        //   this.user = user;
        //   if (this.user && this.registry && this.registry.userId === this.user.userId && !this.createMode) {
        //     // this.router.navigate(["coming-soon"]);
        //     
        //     this.preview = true;
        //     this.isLoggedIn = false;
        //   }
        // });


        if(location.pathname.includes('your-registry') && this.preview){
this.isLoggedIn = false;
this.preview = true;
this.gift = this.gifts.filter(gifts => gifts.friendlyUrl.toLowerCase() === this.giftName.toLowerCase())[0];
;
this.setPortions();
        } else {
          this.registryFirebaseService.currentRegistry.takeUntil(this.ngUnsubscribe).subscribe(registry => {
          ;
            if (this.giftName) {
              this.gift = this.gifts.filter(gifts => gifts.friendlyUrl.toLowerCase() === this.giftName.toLowerCase())[0];
              if (this.gift) {
                document.title = this.gift.title + ' | Hitchd';
                this.registryService.setWebsiteUrl(this.gift);
              }
              this.setPortions();
            }
            this.registryService.SetGiftTitle(this.giftName);
            this.registryService.giftSelection = null;
            this.registryService.selectedGift = null;
  
            if (this.giftName !== undefined) {
              this.loadGift(this.giftName, registry);
            }
  
            if (this.gift && !(this.fromBag || this.fromContrib)) {
              this.filteredGifts = this.gifts.filter(gift => gift.id !== this.gift.id && gift.status === 'active');
  
            }
          });
        }


      }
      );

    });

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  setBaseTemplate(registry: Registry) {
    if (registry.isDemo) {
      localStorage.setItem('baseRegistryName', registry.registryName);

    }
  }


  scrollDown() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  focusDown() {
    const anchor = document.getElementById('mobile-price');
    if (anchor) anchor.focus();

  }

  goToBag() {
    if (!this.isLoggedIn) {
      this.router.navigate(['/' + this.registryName + '/bag']);
    } else {
      this.router.navigate(['registry/bag']);
      return;
    }

  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }

  deleteGift(giftId: string) {
    this.registryFirebaseService.removeGift(this.gift, this.registry);
    this.router.navigate(['registry']);
  }

  handleKeyboardEvents(event: any) {
    // if (!this.showControls)
    //   return;




    if (event.keyCode === 27) {

      this.close('');
    }
  }
  back() {
    window.history.back();

  }

  clickHitchdLogo() {
    const currentUrl = location.href.toLowerCase();
    const hasPreview = currentUrl.includes('preview=1');
    let returnAddress = '';

    // Check if URL contains /registry/
    if (currentUrl.includes(`/${this.registry.registryName}/registry`)) {
      returnAddress = `/${this.registry.registryName}/registry`;
    } else if (currentUrl.includes(`/${this.registry.registryName}`)) {
      returnAddress = `/${this.registry.registryName}`;
    }

    // Append preview parameter if it exists in current URL
    if (hasPreview) {
      returnAddress += '?preview=1';
    }

    this.router.navigateByUrl(returnAddress);
  }

  close(url: string) {
    //
    let returnAddress = "/"+this.registryName;
    if(location.href.toLowerCase().includes('/registry/')){
      returnAddress =  "/"+this.registryName +"/registry"
    }
    if (this.preview && this.fundedgift) {
      this.router.navigate([returnAddress+'/registry']);
      return
    } else  if (this.preview) {
      const currentPath = window.location.pathname;
      const newPath = currentPath.split('/').slice(0, -1).join('/');
      
      this.router.navigateByUrl(newPath + '?preview=1');
      return;
    } else {
      window.history.back();
    }

  }
  backToRegistry(){}

  getParams() {
    const baseUrl = this.gift && this.gift.imageUrl ? this.gift.imageUrl : '';
    if (!this.gift.cropParams) {
      return this.imageUrlService.getHeroImageUrl(baseUrl).split('?')[1];
    } else {
      return this.imageUrlService.getStandardImageUrl(baseUrl).split('?')[1] + this.gift.cropParams;
    }
  }

  getVideoPosterUrl() {
    const imageUrl = this.gift && this.gift.imageUrl ? this.gift.imageUrl : '';
    return this.imageUrlService.getVideoPosterUrl(imageUrl);
  }



  getGiftUrlWithoutHex() {
    if (this.gift && this.gift.imageUrl)
      return this.registryService.cleanImageUrlRemoveHex(this.gift.imageUrl);
  }

  getStandardImageUrl(): string {
    const imageUrl = this.gift && this.gift.imageUrl ? this.gift.imageUrl : '';
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
  color() {
    if (this.gift) {
      return this.registryService.getColor(this.gift.imageUrl);
    }
  }
  changeLang(){
    this.showTranslation = !this.showTranslation;
    if(this.showTranslation){
      
    localStorage.setItem('showTranslation', 'true')
    } else {
      if(localStorage.getItem('showTranslation'))
        
      localStorage.removeItem('showTranslation')
    }
    this.registryService.emitLanguageChange(this.showTranslation);
    }
  openLink(){
    if(!this.gift.website) {
      return;
    }
    if (this.gift.website.startsWith('http://') || this.gift.website.startsWith('https://')){
      this._analyticsService.trackEvent('Visit Gift Url', { visit_url: this.gift.website })
    window.open(this.gift.website, '_blank').focus();
  } else {
    this._analyticsService.trackEvent('Visit Gift Url', { visit_url: 'https://' + this.gift.website })
    window.open('https://' + this.gift.website, '_blank').focus();
  }
  }
  navigate(back: boolean) {

    const activeGifts = this.gifts;
    let giftIndex = activeGifts.map(y => y.id).indexOf(this.giftSelection.gift.id);
    //
    this._cartService.checkCart(this.gifts);
    //  console.log("isback ": +back)
    let nextGift: Gift;
    if (back) {
      if (giftIndex === 0) {
        giftIndex = activeGifts.length - 1;

        nextGift = activeGifts[giftIndex];
      }
      else {

        nextGift = activeGifts[giftIndex - 1];
      }
    }
    else {
      // fwd
      if (giftIndex === activeGifts.length - 1) {
        giftIndex = 0;
        nextGift = activeGifts[giftIndex];
      }
      else {
        nextGift = activeGifts[giftIndex + 1];
      }
    }

    //  console.log("isback " + nextGift.title);
      this.registryService.emmitNextGift(nextGift);
    //   this.gift = nextGift
    if (this.isLoggedIn) {
      this.router.navigate(['/registry/', nextGift.friendlyUrl.toLowerCase()]);
    }
    else if (this.preview) {
      this.router.navigateByUrl('/' + this.registry.registryName + '/' + nextGift.friendlyUrl.toLowerCase() + '?preview=1');
    }
    else {
      this.router.navigate(['/', this.registry.registryName, nextGift.friendlyUrl.toLowerCase()]);
    }

  }




  selectGift(gift: Gift) {
    this.router.navigate(['/' + gift.friendlyUrl.toLowerCase()]);
    window.location.reload();
  }

  ngOnInit() {

  }

  setPortions() {
    if (this.gift.portions) {
      this.gift.price = this.gift.pricePerPortion * this.gift.portions;
      this.pricePerPortion = this.registryService.getPortionsPricePerPortion(this.gift)
      this.portionsRemaining = this.registryService.getPortionsRemaining(this.gift)
    }
  }

  loadGift(giftName: string, registry: Registry): void {

    this.giftSelection = this.registryService.getGiftSelection(giftName, this.gifts, registry);
    if (this.gift === null || this.giftSelection === null || this.giftSelection.gift === null) {

      this.router.navigate(['/404']);
    } else if (!this.gift) {
      this.gift = this.giftSelection.gift;
      this.setPortions();
    }


  }



}



// WEBPACK FOOTER //
// ./src/app/gift-detail/gift-detail.component.ts